export const CheckboxGroup = ({ label, name, value, options, onChange, disabled, isReport }) => {
    const handleChange = (optionValue) => {
        const newValue = value.includes(optionValue)
          ? value.filter((val) => val !== optionValue)
          : [...value, optionValue];
      
        onChange({
          target: {
            name,
            value: newValue
          }
        });
      };

    if (isReport) {
  const safeValue = Array.isArray(value) ? value : [];
  return (
    <p>{label}: {safeValue.join(", ")}</p>
  );
}

    return (
      <div className="checkbox-group">
        <div className="form-group">
          <label>{label}</label>
          <div className="client-type">
            {options.map((option, index) => (
              <label key={index} className="custom-checkbox" htmlFor={`checkbox-${name}-${index}`}>
                <input
                  type="checkbox"
                  id={`checkbox-${name}-${index}`}
                  name={name}
                  value={option.value}
                  checked={value.includes(option.value)}  // Checked if the option is in the selected values
                  onChange={() => handleChange(option.value)}  // Handle selection change
                  disabled={disabled}  // Disable if needed
                />
                <span className="checkmark"></span> {option.display_value}
              </label>
            ))}
          </div>
        </div>
      </div>
    );
  };
  